<template>
  <div>
  <v-container>
    <v-snackbar v-model="snackbar1" :timeout="4000" top color="success">
        <span>{{sucMsg}}</span> 
        <v-btn text color="white" @click="snackbar1 = false">Close</v-btn>
    </v-snackbar>
    <v-snackbar v-model="snackbar2" :timeout="4000" top color="red">
        <span>{{ErMsg}}</span> 
        <v-btn text color="white" @click="snackbar2 = false">Close</v-btn>
    </v-snackbar>
     <v-dialog v-model="dialog" max-width="500" persistent>
                <v-card class="pa-7" color="#e0e0e0" >
                    <v-card-text class="text-center">
                        <v-avatar color="white" size="90" class="mt-n3">
                            <v-icon color="green" x-large>mdi-check-bold</v-icon>
                        </v-avatar>
                    </v-card-text>
                    <v-card-text class="text-center black--text">{{msg}}. </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn to="/invest">Pay Now</v-btn>
                        <v-btn @click="dialog=false">Pay Later</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>


     <div class="mt-8 mx-3">
         <router-link to="/farms/admin" class="" style="text-decoration: none; color:#48c074;"><v-icon left style="color:#48c074;">mdi-arrow-left</v-icon>Back to Farms</router-link>
      </div>

      <!-- error display -->
     <p v-if="isError" class="red--text text-center">{{errMsg}}</p> 
  
       <h3 class="mt-5 mx-3">{{Farms.name}} <v-chip  
      v-bind:class="[Farms.isActive ? 'green' : 'red']" dark>
       {{Farms.isActive ? "Active" : "Inactive"}}</v-chip></h3>
     <div class="container">
        <div class="row">
          <div class="col-lg-12 mb-3">
            <div class="card">
              <div class="card-body card-product">
                <div class="row">
                  <div class="col-lg-4">
                    <div class="text-center">
                      <img :src="getImageUrl(Farms.farm_img_url)" class="img-fluid" alt="third"  />
                      
                      <h5 class="card-title text-center">{{Farms.name}}</h5>
                      <h4 class="card-title text-color text-center"><i>{{Farms.units_avail}} units left</i></h4>
                    </div>
                  </div>
                  <div class="col-lg-8">
                    <h6 class="card-text mx-4 mt-4 text-color">Duration: <span style="font-weight: bold;">{{Farms.duration}}</span> </h6>
                    <h6 class="card-text mx-4 text-color mt-3">Cost: <span style="font-weight: bold;">&#8358;{{Farms.cost}} <small>per unit</small></span></h6>
                    <h6 class="card-text mx-4 text-color mt-3">ROI:  <span style="font-weight: bold;">{{Farms.roi}}%</span></h6>
                    <h6 class="card-text mx-4 text-color mt-3">Location:  <span style="font-weight: bold;">{{Farms.location}}</span></h6>
                    <h6 class="card-text mx-4 text-color mt-3">Category:  <span style="font-weight: bold;">{{Farms.category}}</span></h6>
                    <h6 class="card-text mx-4 text-color mt-3">Investment Code:  <span style="font-weight: bold;">{{Farms.investment_code}}</span></h6>
                    <h6 class="card-text mx-4 text-color mt-3"><v-chip  style="font-weight: bold;" color="red" dark v-if="Farms.isSoldOut===true">Sold Out</v-chip></h6>
                  </div>
                </div>
                
                <div class="row">
                  <div class="col-lg-12">
                    <h5 class="text-color mx-4"><u>Description</u></h5>
                    <h6 class="card-text mx-4 mt-4 text-color" style="line-height: 1.5">{{Farms.description}}</h6>
                  </div>
                </div>
                  <div class="text-center mt-4 mb-4">
                    <button :disabled="loading" v-if="Farms.isActive===false" class="btn btn-green" @click="Activate($event)">
                      Activate <span class="fa fa-circle-o-notch fa-spin" v-if="loading"></span></button>
                  </div>
                     <div class="text-center mt-4 mb-4">
                    <button :disabled="loading" v-if="Farms.isActive===true" class="btn btn-red" @click="Deactivate($event)">
                      Deactivate <span class="fa fa-circle-o-notch fa-spin" v-if="loading"></span></button>
                  </div>
              </div>
            </div>
          </div>
            
            
        </div> 
    </div>
  </v-container>



</div>

</template>

<script>
// import cogoToast from 'cogo-toast';
export default {
  data(){
    return{
      loading: false,
      snackbar: false,
      snackbar1: false,
      snackbar2: false,
      dialog: false,
      sucMsg: '',
      ErMsg: '',
      msg: ''
    }
  },
 computed:{
     Farms(){
        let farm= this.$store.state.farm.farmsbyid
        farm.cost = parseFloat(farm.cost).toFixed(2)
        farm.cost = farm.cost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        farm.units_avail = farm.units_avail.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return farm
      },
    },
     methods:{
    getImageUrl(url){
      return url
    },
    Activate(event){
      event.preventDefault()
          this.loading = true
            this.$store.dispatch("ActivateFarm", this.$store.state.farm.farmsbyid._id)
            .then(()=>{
            this.loading= false
            this.sucMsg="Farm successfully activated"
            this.snackbar1=true
            this.$store.dispatch("GetFarmsById",this.$store.state.farm.farmsbyid._id)
          })
          .catch((error)=>{
            this.loading= false
            this.ErMsg= error.response.data.message
            this.snackbar2 =true
          });
    },
      Deactivate(event){
      event.preventDefault()
          this.loading = true
            this.$store.dispatch("DeactivateFarm",this.$store.state.farm.farmsbyid._id)
            .then(()=>{
            this.loading= false
            this.sucMsg = "Farm successfully deactivated"
            this.snackbar1=true
            this.$store.dispatch("GetFarmsById",this.$store.state.farm.farmsbyid._id )
          })
          .catch((error)=>{
            this.loading= false
            this.ErMsg= error.response.data.message
            this.snackbar2 =true
          });
    }
  }
}
</script>

<style scoped>
.btn-red{
    background: red;
    border-radius: 38.5px;
    color: #fff;
    padding: 10px 25px;
    transition: all 0.5s;
}
.btn-red:hover{
    background: #fff;
    box-shadow: 0px -2px 10px rgba(255, 255, 255, 0.14), 0px 4.5px 10px rgba(255, 255, 255, 0.14);
    color: red;
    border: 1px solid red;
  }
</style>